module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Bold.adfad437.ttf";